import { useEffect, useState } from 'react';
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

/**
 * Aggregated fetch-on-mount hook for non-mutating dashboard data:
 * - extensions catalogue
 * - subscription plans
 * - style presets by document type
 *
 * One hook so the Dashboard doesn't need three useEffects.
 */
export const useDashboardCatalog = () => {
  const [extensions, setExtensions] = useState([]);
  const [subscriptionPlans, setSubscriptionPlans] = useState([]);
  const [stylePresets, setStylePresets] = useState({ manuscript: [], screenplay: [], song: [] });

  useEffect(() => {
    let alive = true;
    const fetchAll = async () => {
      try {
        const [extRes, planRes, styleRes] = await Promise.all([
          axios.get(`${API}/extensions`, { withCredentials: true }),
          axios.get(`${API}/subscription-plans`, { withCredentials: true }),
          axios.get(`${API}/style-presets`, { withCredentials: true }),
        ]);
        if (!alive) return;
        setExtensions(extRes.data.extensions || []);
        setSubscriptionPlans(planRes.data.plans || []);
        setStylePresets(styleRes.data || { manuscript: [], screenplay: [], song: [] });
      } catch (err) {
        if (process.env.NODE_ENV !== 'production') {
          console.error('Catalog fetch failed:', err?.message);
        }
      }
    };
    fetchAll();
    return () => { alive = false; };
  }, []);

  return { extensions, subscriptionPlans, stylePresets };
};
